import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { apiClient } from '../../../helpers/apiHelperV2';
import Input from '../../components/form-elements/Input';
import Button from '../../components/form-elements/Button';

const zipCodeSchema = Yup.object().shape({
    zipCode: Yup.string()
        .required('Bitte geben Sie eine Postleitzahl ein.')
        .test('zipCode', 'Die eingegebene Postleitzahl ist ungültig. Bitte geben Sie eine 5-stellige deutsche PLZ ein.', async function (zipCode) {
            if (zipCode && zipCode.length === 5) {
                try {
                    const {
                        data: { isValid },
                    } = await apiClient.post('/api/v1/validation/zipCode', { zipCode });
                    return isValid;
                } catch (err) {
                    console.error(err);
                    return this.createError({ message: 'Die Postleitzahl konnte nicht überprüft werden. Bitte versuchen Sie es erneut.' });
                }
            }
            return false;
        }),
});

function LocationSelector({ onSubmit }) {
    return (
        <div>
            <div className="uk-background-muted uk-padding" data-uk-margin="">
                <div className="uk-text-large uk-text-center" id="instruction-zip">
                    Geben Sie Ihre <strong>Postleitzahl</strong> ein und wählen Sie ein
                    <br />
                    <strong>Autohaus in Ihrer Nähe.</strong>
                    <br />
                    Der Produktpreis erscheint nach der Auswahl.
                </div>
                <Formik
                    initialValues={{ zipCode: '' }}
                    validationSchema={zipCodeSchema}
                    onSubmit={onSubmit}
                    render={({ touched, values, errors, setFieldValue }) => {
                        const showError = touched.zipCode && errors.zipCode;
                        const ariaDescribedBy = showError ? 'instruction-zip error-zip' : 'instruction-zip';
                        return (
                            <Form className="uk-form">
                                <Input
                                    name="zipCode"
                                    value={values.zipCode}
                                    placeholder="PLZ eingeben z.B.10117"
                                    onChange={({ name, value }) => setFieldValue(name, value)}
                                    error={showError ? (
                                        <div id="error-zip" role="alert">
                                            {errors.zipCode}
                                        </div>
                                    ) : undefined}
                                    ariaLabel="Postleitzahl hier eingeben"
                                    aria-describedby={ariaDescribedBy}
                                    autoComplete="on"
                                />
                                <Button fullWidth type="submit" ariaLabel="Lokales Autohaus auswählen">
                                    Lokales Autohaus auswählen
                                </Button>
                            </Form>
                        );
                    }}
                />
            </div>
        </div>
    );
}

export default LocationSelector;
